<template>
    <div class="modal-container" :class="rootClass">
        <component
            v-for="item in items"
            v-bind:is="item.component"
            :key="item.key"
            v-bind="item.props"
            :item="item"
            @remove="onItemRemove"
        />
    </div>
</template>

<script>
import { getAppInstance } from '@/modules/app'
import ModalsModule from '@/modules/modals'

export default {
    components: {
    },
    inheritAttrs: false,
    data() {
        return {
            items: [],
            keyIndex: 0
        }
    },
    mounted() {
        const modalsModule = getAppInstance().getModuleByType(ModalsModule)
        modalsModule.registerModuleContainerAddItemFunction(this.addItem)
    },
    computed: {
        rootClass() {
            return this.items.length > 0 ? 'modal-container-show' : 'modal-container-hide'
        }
    },
    methods: {
        getNextKey() {
            this.keyIndex++
            return this.keyIndex
        },
        addItem(item) {
            if (!item.props) item.props = {}
            item.props.modalId = item.id
            item.key = this.getNextKey()
            this.items.push(item)
        },
        removeItem(item) {
            const index = this.items.indexOf(item)
            if (index >= 0) this.items.splice(index, 1)
        },
        removeItemsById(id) {
            const itemsToRemove = []
            this.items.forEach(item => {
                if (item.id === id) itemsToRemove.push(item)
            })
            itemsToRemove.forEach(item => {
                this.removeItem(item)
            })
        },
        onItemRemove(componentInstance) {
            this.items.forEach(item => {
                console.log('check', item, componentInstance, componentInstance.modalId, componentInstance.$attrs.modalId, item.id === componentInstance.modalId, item.id === componentInstance.$attrs.modalId)
                if (item.id === componentInstance.modalId || item.id === componentInstance.$attrs.modalId) {
                    this.removeItem(item)
                }
            })
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.modal-container
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh
    z-index 2000
    pointer-events none

    &.modal-container-hide
        // display none
        todo tada
</style>



// WEBPACK FOOTER //
// src/modules/modals/components/ModalContainer.vue